<div class="download-header">
  <p class="name-container">
    <inline-svg src="Reports.svg" class="reports-icon" (click)="goBack()"></inline-svg>
    <inline-svg src="arrow-middle.svg" class="arrow-icon"></inline-svg>
    @if (!editMode) {
      <span (click)="navigateBreadCrumbs(false, depthLvl == 1)"
      [ngClass]="{'crumb_last': depthLvl == 1}" class="crumb">{{ report?.name || "Report" }}</span>
      @if (!breadCrumbs.length) {
        <inline-svg src="edit.svg" class="edit-icon" (click)="enterEditMode()"></inline-svg>
      }
    }
    @for (crumb of breadCrumbs; track crumb; let last = $last; let index = $index) {
      <inline-svg src="arrow-middle.svg" class="arrow-icon"></inline-svg>
            <span [ngClass]="{'navigate': !last,
            'crumb_last': last}" (click)="navigateBreadCrumbs(true, last)" class="crumb">{{ crumb }}</span>
    }

    <!--        <img src="assets/icons/page_back.svg" alt="" width="8px" height="13px"-->
    <!--             (click)="goBack()">-->


    @if (editMode) {
      <mat-form-field appearance="outline">
        <input matInput [formControl]="reportNameCtrl">
      </mat-form-field>
      <button mat-button class="frmg-primary-button"
        (click)="updateReportName()">
        <inline-svg src="check.svg" class="edit-action-icon" color="#F7F9F9"></inline-svg></button>
        <button mat-button class="frmg-secondary-button"
          (click)="enterEditMode()">
          <inline-svg src="small_close.svg" class="edit-action-icon" color="#A5B5BD"></inline-svg></button>
        }

      </p>
      <div>

        <button mat-raised-button class="frmg-primary-button" [matMenuTriggerFor]="downloadMenu"
          #menuOpen='matMenuTrigger'
          [ngClass]="{'menu-open': menuOpen.menuOpen}">
          <span>Download Report </span>
          <div class="separator"></div>
          <inline-svg src="Input_arrow.svg" class="arrow-icon"></inline-svg>
        </button>
        @if (report?.user?.email === currentUser.email && depthLvl == 1) {
          <button mat-raised-button class="frmg-secondary-button"
            (click)="share(report, $event)">
            <inline-svg src="share.svg" class="header-action-icon"></inline-svg>
          </button>
        }
        @if ((!report?.user ||report?.user?.email === currentUser.email) && depthLvl == 1) {
          <button mat-raised-button class="frmg-secondary-button"
            (click)="deleteReport(report, $event)">
            <inline-svg src="remove.svg" class="header-action-icon"></inline-svg>
          </button>
        }
        @if ((report?.user  && report?.user?.email !== currentUser.email) && depthLvl == 1) {
          <button mat-raised-button class="frmg-secondary-button"
            (click)="unShareReport(report, $event)">
            <inline-svg src="unshare.svg" class="header-action-icon"></inline-svg>
          </button>
        }
      </div>
      <mat-menu #downloadMenu="matMenu" xPosition="before" class="download-menu-panel header-download-menu">
        <!--        <span> Download in CSV</span>-->
        <!--        <span> Download in XLSX</span>-->
        <!--        <span style="min-width: 209px" (click)="download(id, report.name+'_report')"> Download in PDF</span>-->
        <span style="min-width: 209px" (click)="downloadXLSX(id, report.name+'_report')"> Download in XLSX</span>
      </mat-menu>
    </div>
    @if (depthLvl === 3) {
      <div class="layers_conf">
        <nav mat-tab-nav-bar [tabPanel]="tabPanel">
          @for (link of layers; track link) {
            @if (!(link.layer_name === 'Exposure' && this.isPoint) ) {
              <a mat-tab-link
                (click)="selectLayer(link)"
              [active]="activeLayer === link.layer_name"> {{layerLabelTransform(link.layer_name)}} </a>
            }
          }
        </nav>
        <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
      </div>
    }
    <router-outlet [id]="id"></router-outlet>
